export const COOKIE_MAX_AGE_1_YEAR = 365 * 24 * 60 * 60;

export const LOCALSTORAGE = {
  ACCESS_TOKEN: "access_token",
  USER_ACCESS_TOKEN: "user_access_token",
  CONTRACTOR_ACCESS_TOKEN: "contractor_access_token",

  // ✅ Master keys (ADD)
  MASTER_ACCESS_TOKEN: "MASTER_ACCESS_TOKEN",
  MASTER_USER_ID: "MASTER_USER_ID",

  USER_DATA: "user-data",
  USER_ID: "user-id",
  COMPANY_DATA: "company-data",
  COMPANY_ID: "company-id",
  COMPANY_TYPE: "company-type",
  SUBSCRIPTION_STATUS: "subscription-status",
  SUBSCRIPTION_KEY: "subscription-key",
  SUBSCRIPTION_START_DATE: "subscription-start-date",
  SUBSCRIPTION_END_DATE: "subscription-end-date",
  USER_ROLE: "user_role",
  PROJECT_ID: "project_id",
  DEFAULT_ACCESS: "default_access",
  COMPANY_IDS: "company_ids",
  PROJECT_IDS: "project_ids",
  UNIT_IDS: "unit_ids",
  CURRENT_UNIT: "current_unit",
  CURRENT_PROJECT: "current_project",
  CURRENT_COMPANY: "current_company",

  // Contractor specific keys
  CONTRACTOR_ROLE: "contractor_role",
  CONTRACTOR_USER_ID: "contractor_user_id",
  CONTRACTOR_NAME: "contractor_name",
  CONTRACTOR_COMPANY_ID: "contractor_company_id",
  CONTRACTOR_DEFAULT_ACCESS: "contractor_default_access",
};

export const ERROR_MESSAGES = {
  SERVER_ERROR: "Server error",
  WRONG_CREDENTIALS_ERROR: "Wrong username and/or password",
  CONTRACTOR_ERROR: "Contractor authentication failed",
};

export const RoleActions = {
  None: "none",
  Create: "create",
  Read: "read",
  Update: "update",
  Delete: "delete",
};

export const RoleSubjects = {
  None: "none",
  All: "all",
  // Admin subjects
  AdminDashboard: "admin-dashboard",
  AdminProject: "admin-project",
  AdminUser: "admin-user",
  AdminAppointment: "admin-appointment",
  AdminWorkOrder: "admin-work-order",
  AdminBooking: "admin-booking",
  AdminUnit: "admin-unit",
  AdminFacility: "admin-facility",
  AdminPost: "admin-post",
  AdminInventory: "admin-inventory",
  // User subjects (Owner/Tenant)
  UserDashboard: "user-dashboard",
  UserAppointment: "user-appointment",
  UserWorkOrder: "user-work-order",
  UserBooking: "user-booking",
  UserUnit: "user-unit",
  UserFacility: "user-facility",
  UserPost: "user-post",
};

export const Roles = {
  SuperAdmin: "superadmin",
  Admin: "admin",
  Owner: "owner",
  Tenant: "tenant",
  Contractor: "contractor",
  Master: "master",
};

export const WorkOrder = {
  // Type constants
  TYPE_PREVENTIVE: "preventive",
  TYPE_CORRECTIVE: "corrective",
  TYPE_EMERGENCY: "emergency",
  TYPE_SAFETY: "safety",
  TYPE_UPGRADE: "upgrade",

  // Priority constants
  PRIORITY_LOW: "low",
  PRIORITY_MEDIUM: "medium",
  PRIORITY_HIGH: "high",
  PRIORITY_URGENT: "urgent",
  PRIORITY_EMERGENCY: "emergency",

  // Status constants
  STATUS_DRAFT: "draft",
  STATUS_PENDING: "pending",
  STATUS_APPROVED: "approved",
  STATUS_IN_PROGRESS: "in_progress",
  STATUS_ON_HOLD: "on_hold",
  STATUS_COMPLETED: "completed",
  STATUS_CANCELLED: "cancelled",
  STATUS_REJECTED: "rejected",
};
